import {useContext, useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {LoginContext} from "../utils/Auth";

const useCheckLogin = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {isUserIn, setIsUserIn} = useContext(LoginContext);

    useEffect(() => {
        const token = localStorage.getItem("X-Authorization");
        if (token && token.trim() !== "") {
            if (!isUserIn) setIsUserIn(true);
            if (["/login", "/register", "/auth"].some(p => location.pathname.startsWith(p))) {
                navigate("/dashboard", {replace: true});
            }
        } else {
            if (
                location.pathname.startsWith("/dashboard") ||
                location.pathname.startsWith("/search") ||
                location.pathname.startsWith("/settings") ||
                location.pathname.startsWith("/box-details")
            ) {
                navigate("/login", {replace: true});
            }
        }
    }, [isUserIn, setIsUserIn, navigate, location.pathname]);

    return isUserIn;
};

export default useCheckLogin;
